/* Mobile star-rating gallery overlay
   ----------------------------------
   On phone/tablet viewports the `.dd-block--star-rating` section block is
   moved INTO `.dd-gallery-card` as an absolutely-positioned chip in the
   gallery's bottom-left corner — the same corner the existing
   `_sampleZoomContrast` luminance sampler already reads, so the chip's
   text/border colors flip via `.dd-gallery-card.--on-light` for free.

   On desktop (>=1024px) the block stays in its original flex-stack slot.
   We track the original parent + nextSibling so the move is fully
   reversible across viewport resizes (devtools, orientation change). */
(function () {
  if (window.__ddPdpRatingOverlayInit) return;
  window.__ddPdpRatingOverlayInit = true;

  var MOBILE_MQ = '(max-width: 1023px)';

  function init() {
    var card = document.querySelector('.dd-gallery-card');
    if (!card) return;
    var block = document.querySelector('.dd-block--star-rating');
    // Proceed if there's a rating chip to relocate OR a texture note to surface
    // (the note must still appear on products that have no rating block).
    if (!block && !card.querySelector('.dd-gallery-card__texture-note')) return;

    var origParent = block ? block.parentNode : null;
    var origNext = block ? block.nextSibling : null;

    // Shared bottom-left flex column so the rating chip and the texture
    // disclaimer note stack (with a gap) instead of colliding.
    function getStack() {
      var stack = card.querySelector('.dd-gallery-card__overlay-bl');
      if (!stack) {
        stack = document.createElement('div');
        stack.className = 'dd-gallery-card__overlay-bl';
        card.appendChild(stack);
      }
      return stack;
    }

    function moveIn() {
      var stack = getStack();
      // Texture note on top, rating chip below (appendChild is idempotent).
      var note = card.querySelector('.dd-gallery-card__texture-note');
      if (note) stack.appendChild(note);
      if (block) {
        block.classList.add('dd-gallery-card__rating');
        stack.appendChild(block);
      }
    }

    function moveOut() {
      var stack = card.querySelector('.dd-gallery-card__overlay-bl');
      if (block && block.classList.contains('dd-gallery-card__rating')) {
        block.classList.remove('dd-gallery-card__rating');
        if (origParent && origParent.isConnected) {
          origParent.insertBefore(block, origNext);
        }
      }
      if (stack) {
        // Park the note back on the card (CSS hides it outside the stack).
        var note = stack.querySelector('.dd-gallery-card__texture-note');
        if (note) card.appendChild(note);
        if (stack.children.length === 0) stack.remove();
      }
    }

    // Surface the texture note ONLY while its image (the 2nd) is the one actually
    // in view, not across the whole gallery. Class-based signals are unreliable
    // here (`is-active` is only set on thumbnail taps, not free swipes), so we
    // measure real geometry: how much of the texture slide overlaps its own
    // scroller's viewport. The actual horizontal scroller is the
    // `.product__media-list` <ul> (it owns `overflow-x: auto`), NOT the
    // <slider-element> wrapper — scroll events don't bubble, so the listener
    // must sit on the <ul> or it never fires on swipe. We derive it from the
    // slide via closest() so the relationship is always correct.
    // (CSS only renders the note inside the mobile stack, so this is a harmless
    // no-op on desktop.)
    var note = card.querySelector('.dd-gallery-card__texture-note');
    if (note) {
      var textureId = note.getAttribute('data-texture-media-id');
      var slide = textureId
        ? card.querySelector(
            '.product__media-item[data-media-id="' + textureId + '"]'
          )
        : null;
      var scroller = slide ? slide.closest('.product__media-list') : null;
      if (slide && scroller) {
        var syncNote = function () {
          var sr = scroller.getBoundingClientRect();
          var tr = slide.getBoundingClientRect();
          var overlap =
            Math.min(sr.right, tr.right) - Math.max(sr.left, tr.left);
          var ratio = tr.width > 0 ? overlap / tr.width : 0;
          note.classList.toggle('is-on', ratio >= 0.6);
        };
        // Re-measure across a short window so we catch the settled position
        // whether the change was a smooth scroll or an instant jump.
        var syncSoon = function () {
          requestAnimationFrame(syncNote);
          setTimeout(syncNote, 150);
          setTimeout(syncNote, 450);
        };
        // Swipe path: the scroller fires scroll events as the user drags.
        scroller.addEventListener('scroll', syncNote, { passive: true });
        window.addEventListener('resize', syncNote);
        // Thumbnail-tap path: the gallery jumps to the slide, which can land
        // without a catchable scroll event, so re-measure after any rail tap.
        var rail =
          card.querySelector('.dd-thumb-list') ||
          card.querySelector('media-dots') ||
          card.querySelector('.dd-gallery-mobile-rail');
        if (rail) rail.addEventListener('click', syncSoon);
        // Run once layout has settled (slides measure 0 before first paint).
        syncSoon();
      }
    }

    var mq = window.matchMedia(MOBILE_MQ);

    function apply() {
      if (mq.matches) moveIn();
      else moveOut();
    }

    apply();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
    } else if (typeof mq.addListener === 'function') {
      // Safari < 14 fallback.
      mq.addListener(apply);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
